import { Avatar } from "@mui/material";
import MAccordion from "@mui/material/Accordion";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const HistoryHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flex: "1 0 0",
}));

export const HistoryTitle = styled("span")(() => ({
  color: colors.gray600,
  font: "700 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const HistoryCount = styled("div")(() => ({
  display: "flex",
  padding: "0px 4px",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: "100px",
  background: colors.gray600,
  color: colors.white,
  font: "600 11px Manrope",
  lineHeight: "16px",
}));

export const Accordion = styled(MAccordion)(() => ({
  width: "100%",
  minHeight: "56px",
  padding: "4px 8px",
  background: colors.gray50,
  borderBottom: `1px solid ${colors.gray200}`,
  borderRadius: "0px",
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "24px",
  [`& .${accordionSummaryClasses.content}`]: {
    margin: 0,
  },
}));

export const HistoryContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  background: colors.gray50,
  padding: "0 16px",
  flexDirection: "column",
  maxHeight: "120px",
  overflow: "auto",
}));

export const HistoryItem = styled("div")(() => ({
  display: "flex",
  padding: "12px 0",
  alignItems: "center",
  width: "100%",
  gap: "12px",
  borderBottom: `1px solid ${colors.gray200}`,
  "&:last-child": {
    border: 0,
  },
}));

export const HistoryItemMessage = styled("span")(() => ({
  color: colors.gray800,
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const HistoryItemTime = styled("span")(() => ({
  color: colors.gray500,
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const HistoryAvatar = styled(Avatar)(() => ({
  width: "32px",
  height: "32px",
  color: colors.white,
  textAlign: "center",
  font: "700 14px Manrope",
  lineHeight: "14px",
  letterSpacing: "0.25px",
  backgroundColor: colors.indigo400,
}));
